import React, { useContext, useState, useEffect } from 'react';
import "./Landing.css";
import { Packs } from '../Context/PacksContext';
//import PackRectangle from "../../Photos/PackRectangle.png"
import YMCInstructions1 from "../../Photos/LandingInstruction1.png"
import YMCInstructions3 from "../../Photos/LandingInstruction3.png"
//import YMCBlockImage6 from "../../Photos/YMCBlockImage6.png"
//import YMCSwirlyLines1 from "../../Photos/YMCSwirlyLines1.png"
//import YMCSwirlyLines2 from "../../Photos/YMCSwirlyLines2.png"
//import YMCSwirlyLines3 from "../../Photos/YMCSwirlyLines3.png"
//import YMCSwirlyLines4 from "../../Photos/YMCSwirlyLines4.png"
//import YMCSelfCareImage from "../../Photos/LandingSelfCareBlock.png"
import MakeItEasy from "./MakeItEasy"
import DidYouKnow from "./DidYouKnow"
import YouCanTrust from "./YouCanTrust"
/* import Newsletter from "../ContactRoute/Newsletter"
 */import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpLong } from "@fortawesome/free-solid-svg-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
//import { faHeart } from "@fortawesome/free-regular-svg-icons";
//import packslist from "../../../JSONS/updatedPacks.json"
import LazyLoad from 'react-lazyload';
import TrustUs from './TrustUs';
import MedicalOrder from './MedicalOrder';
import BackgroundBlue from '../../Photos/YMCBlockImage6.png'
import Footer from '../Layouts/Footer';



function LandingSlider() {
  const Navigate = useNavigate();

  const re = new RegExp(/^.*\//);
  const root = re.exec(window.location.href)

  window.onscroll = function() {
    if(document.URL === root[0]) {
      let tmp = document.getElementById("ToTheTop")
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        tmp.className = tmp.className.replace(" ScrollBackToTopHidden", "");
      } else {
        if(!tmp.className.includes("ScrollBackToTopHidden")) tmp.className += " ScrollBackToTopHidden"
      }
    }
  }

  //const [Gender, setGender] = useState('Mixed');
  //const [PacksVisible, setPacksVisible] = useState(["CM00YMC001","PM00YMC002","PM40YMC003"]);
  const [GenderPack, setGenderPack] = useState(false);
  const [ToLipidic, setToLipidic] = useState(false)

  //const {
  //  SetVisualizePack, SetChosenPackGender
  //} = useContext(Packs);
  const {
    SetChosenPackGender
  } = useContext(Packs);

  useEffect(() => {
    if(GenderPack) {
      Navigate("/packs-de-examenes")
    }
  });

  useEffect(() => {
    if(ToLipidic) {
      Navigate("/detalles-de-pack?pack=PM00YMC041")
    }
  });


  return (
    <div
      style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh', 
    backgroundImage: `url(${BackgroundBlue})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    zIndex: 0,
    backgroundRepeat: 'no-repeat',
  }}> 
    <div className="LandingSliderDiv">
    <div className="LandingSliderInnerDiv">
    <div className="LandingSliderImageContain">
 
      </div>
   
   <MedicalOrder/>
    <MakeItEasy/>
    <div id='OrderSection'></div>
      <div  className='LandingMedicOrderSection'>
        <div className='plus'></div>
        <div className='LandingMedicOrderSectionTitle'>Encuentra los exámenes que necesitas</div>
        <div className='LandingMedicOrderSectionSubtitle'>Te facilitamos el acceso a ordenes médicas con  exámenes de laboratorio, imágenes y procedimientos que te permiten detectar precozmente patologías como diabetes, hipertensión, dislipidemia y algunos de los cánceres más frecuentes en la población.</div>
      </div>

      <div className='LandingMedicOrderSectionTabContent'>
        <LazyLoad once >
        <div className='LandingMedicOrderSectionTabContentFlex'>
            <div className="LandingMedicOrderSectionTabContentBlockFemale" style={{backgroundImage:"linear-gradient(90deg, rgba(102,51,255,1) 20%, rgba(255,255,255,0) 100%),url('https://static.yomecontrolo.cl/public/img/home/FemaleTabLeft.png')",backgroundPosition: 'top center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>

              <div className="LandingMedicOrderSectionTabContentBlockText">Exámenes Mujeres&nbsp;</div>
              <div className="LandingMedicOrderSectionTabContentBlockButton" onClick={() => {SetChosenPackGender("F"); setGenderPack(true); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>Ir a Exámenes</div>

            </div>
            <div className="LandingMedicOrderSectionTabContentBlockMale" style={{backgroundImage:"linear-gradient(90deg, rgba(40,174,255,1) 20%, rgba(255,255,255,0) 100%),url('https://static.yomecontrolo.cl/public/img/home/MaleTabRight.png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>

              <div className="LandingMedicOrderSectionTabContentBlockText">Exámenes Hombres </div>
              <div className="LandingMedicOrderSectionTabContentBlockButton" onClick={() => {SetChosenPackGender("M"); setGenderPack(true); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}} >Ir a Exámenes</div>

            </div>
        </div>
        </LazyLoad>
      </div>


      </div>
      <div>

      </div>
      <YouCanTrust/>
    <TrustUs/> 
 <Footer/>
    
      <div className='ScrollBackToTopOuter ScrollBackToTopHidden' id="ToTheTop">
        <div className='ScrollBackToTop' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
          <FontAwesomeIcon 
            icon={faUpLong} 
            className='ScrollBackToTopUpArrow'
          />
        </div>
      </div>
    </div>
    </div>
  );
}

export default LandingSlider; 
